import React, { useContext, useEffect, useState } from 'react'
import { Box, Link, Stack, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { Form } from 'react-final-form'
import ReCAPTCHA from 'react-google-recaptcha'
import { isValid } from 'date-fns'
import { connect } from 'react-redux'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { FormApi } from 'final-form'
import { ToastContext } from '../../../../../components/toast/ToastContext'
import { useAppDispatch } from '../../../../../config/hooksUnivers'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import { SIGNUP_OPTIONS } from '../../../authentication/services/loginConstants'
import { ToastType } from '../../../../../components/toast/toastConstants'
import ButtonDefault from '../../../../../components/ButtonDefault'
import CaptchaInput from '../../../../../components/form/CaptchaInput'
import TextInput from '../../../../../components/form/TextInput'
import DatePickerInput from '../../../../../components/form/DatePickerInput'
import { toUpperCase } from '../../../../../utils/stringUtils'
import NissTextInput from '../../../../../components/NissTextInput'
import PatternTextInput from '../../../../../components/PatternTextInput'
import { FORM_REGEX, PATTERNS } from '../../../../../components/formConstants'
import { generalUseUrl, SIGNUP_FIELDS } from '../../services/conjointAccessConstants'
import appConst from '../../../preaffiliation/constants/appConst'
import { isNssValid } from '../../../../../components/fieldsValidation'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import ConfirmationPopin from '../../../../../components/ConfirmationPopin'
import { subscribe } from '../../../authentication/services/inscription/inscriptionActions'
import { reset as resetAction } from '../../services/conjointAccessActions'


const ARTICLE_CONFIRMATION = 'inscription_confirmation'
const ARTICLE_INTRODUCTION = 'partage_inscription_introduction'

const SignupFormConjoint = (
    {
        // @ts-ignore
        confirmationArticle,
        // @ts-ignore
        introductionArticle,
        // @ts-ignore
        getArticleByShortcut,
        // @ts-ignore
        conjoint
    }) => {
    const intl = useIntl()
    const dispatch = useAppDispatch()
    const {addToast} = useContext(ToastContext)
    const {isMobile, isTabletPortrait, isDesktop, isLaptop, isWidescreen} = useBreakpoints()
    const recaptchaRef = React.useRef<ReCAPTCHA>()


    useEffect(() => {
        if(!confirmationArticle){
            getArticleByShortcut(appConst.cardiboxApi, ARTICLE_CONFIRMATION)
        }
        if(!introductionArticle){
            getArticleByShortcut(appConst.cardiboxApi, ARTICLE_INTRODUCTION)
        }
    }, [])


    let openConfirmation: any, setOpenConfirmation: any
    [openConfirmation, setOpenConfirmation] = useState<boolean>(false)

    const isDesktopOrLaptop = isDesktop || isLaptop || isWidescreen

    const onSubmit = (values: SubscribeParams, form: FormApi<SubscribeParams, Partial<Record<string, any>>>) => {
        const {idAdherent, nom, prenom, niss, password, dateNaissance, email, newsletter, captcharesponse} = values
        const newsletterValue = newsletter.includes(SIGNUP_OPTIONS.NEWSLETTER)
        const dateNaissanceValue = new Date(dateNaissance).toLocaleDateString('fr-FR')
        return dispatch(subscribe(idAdherent.replaceAll(' ', ''), nom, prenom, niss.replaceAll('_', '').replaceAll(' ', ''), password, dateNaissanceValue, email, newsletterValue, captcharesponse, true, conjoint.numindivParent))
            .then(() => {
                // inscription success
                setOpenConfirmation(true)
                recaptchaRef.current?.reset()
            }).catch((e: any) => {
                recaptchaRef.current?.reset()
                if (e?.data?._error) {
                    addToast(ToastType.ERROR, e.data._error)
                } else if (e?.data?.globalError) {
                    addToast(ToastType.ERROR, e.data.globalError)
                } else if (e?.data) {
                    addToast(ToastType.ERROR, 'Echec de l\'inscription')
                    return e.data
                } else {
                    addToast(ToastType.ERROR, 'Echec de l\'inscription')
                }
            })
    }

    const required = (value: any) => (value ? undefined : intl.formatMessage({id: 'global.error.required'}))
    const generalConditionRequired = (value: string) => (value ? undefined : intl.formatMessage({id: 'global.error.generalCondition'}))

    const TERMS_AND_CONDITIONS_DATA = [
        {
            label: intl.formatMessage({id: 'login.form.signup.termsAndConditions.generalUse.body'}, {
                link: (
                    <Link href={generalUseUrl} target="_blank" rel="noreferrer noopener">
                        {intl.formatMessage({id: 'login.form.signup.termsAndConditions.generalUse.link'})}
                    </Link>
                )
            }),
            value: SIGNUP_OPTIONS.GENERAL_USE,
            validate: generalConditionRequired
        }
    ]

    return (
        <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
                const errors: any = {}
                if (!values[SIGNUP_FIELDS.PASSWORD]) {
                    errors[SIGNUP_FIELDS.PASSWORD] = intl.formatMessage({id: 'global.error.required'})
                } else if (!FORM_REGEX.PASSWORD.test(values[SIGNUP_FIELDS.PASSWORD])) {
                    errors[SIGNUP_FIELDS.PASSWORD] = intl.formatMessage({id: 'global.error.newpasswordbadFormat'})
                }

                if (!values[SIGNUP_FIELDS.CONFIRM_PASSWORD]) {
                    errors[SIGNUP_FIELDS.CONFIRM_PASSWORD] = intl.formatMessage({id: 'global.error.required'})
                } else if (values[SIGNUP_FIELDS.PASSWORD] !== values[SIGNUP_FIELDS.CONFIRM_PASSWORD]) {
                    errors[SIGNUP_FIELDS.CONFIRM_PASSWORD] = intl.formatMessage({id: 'global.error.passwordsDontMatch'})
                }

                if (values[SIGNUP_FIELDS.EMAIL] !== values[SIGNUP_FIELDS.CONFIRM_EMAIL]) {
                    errors[SIGNUP_FIELDS.CONFIRM_EMAIL] = intl.formatMessage({id: 'global.error.emailsDontMatch'})
                }

                if (!values[SIGNUP_FIELDS.TERMS_AND_CONDITIONS]?.includes(SIGNUP_OPTIONS.GENERAL_USE)) {
                    errors[SIGNUP_FIELDS.TERMS_AND_CONDITIONS] = intl.formatMessage({id: 'global.error.generalCondition'})
                }

                if (!values[SIGNUP_FIELDS.CAPTCHA_RESPONSE]) {
                    errors[SIGNUP_FIELDS.CAPTCHA_RESPONSE] = intl.formatMessage({id: 'global.error.required'})
                }

                if (!values[SIGNUP_FIELDS.BIRTH_DATE]) {
                    errors[SIGNUP_FIELDS.BIRTH_DATE] = intl.formatMessage({id: 'global.error.required'})
                } else if (!isValid(values[SIGNUP_FIELDS.BIRTH_DATE])) {
                    errors[SIGNUP_FIELDS.BIRTH_DATE] = intl.formatMessage({id: 'global.error.format'})
                }

                if (!values[SIGNUP_FIELDS.SOCIAL_SECURITY_NUMBER]) {
                    errors[SIGNUP_FIELDS.SOCIAL_SECURITY_NUMBER] = intl.formatMessage({id: 'global.error.required'})
                } else if (!isNssValid(values[SIGNUP_FIELDS.SOCIAL_SECURITY_NUMBER])) {
                    errors[SIGNUP_FIELDS.SOCIAL_SECURITY_NUMBER] = intl.formatMessage({id: 'global.error.format'})
                }

                return errors
            }}
            render={({handleSubmit, errors}) => (
                <>
                    <Typography variant="h3">
                        {(introductionArticle && introductionArticle.fields) && <div dangerouslySetInnerHTML={{ __html: introductionArticle.fields.body }} />}
                    </Typography>
                    <form onSubmit={handleSubmit}>
                            <Stack direction="column" spacing={5}>
                                <Stack direction="column" spacing={3}
                                       alignItems={!isDesktopOrLaptop ? 'center' : 'unset'}>
                                    <Stack direction={isDesktopOrLaptop ? 'row' : 'column'} spacing={3}
                                           width={isDesktopOrLaptop ? 'unset' : '100%'}>
                                        <PatternTextInput
                                            name={SIGNUP_FIELDS.INSURANCE_NUMBER}
                                            label={intl.formatMessage({id: 'login.form.signup.insuranceNumber.label'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.insuranceNumber.placeholder'})}
                                            helperText={intl.formatMessage({ id: 'activationConjoint.form.signup.insuranceNumber.info' })}
                                            format={PATTERNS.NUM_ASSURE}
                                            validate={required}
                                            defaultValue={conjoint.numindiv}
                                            disabled={true}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                        {isDesktopOrLaptop && <Box maxWidth="350px" width="100%"/>}
                                    </Stack>

                                    <Stack direction={isDesktopOrLaptop ? 'row' : 'column'} spacing={3}
                                           width={isDesktopOrLaptop ? 'unset' : '100%'}>
                                        <TextInput
                                            name={SIGNUP_FIELDS.LAST_NAME}
                                            label={intl.formatMessage({id: 'login.form.signup.lastName.label'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.lastName.placeholder'})}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                            validate={required}
                                        />
                                        <TextInput
                                            name={SIGNUP_FIELDS.FIRST_NAME}
                                            label={intl.formatMessage({id: 'login.form.signup.firstName.label'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.firstName.placeholder'})}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                            validate={required}
                                        />
                                    </Stack>

                                    <Stack
                                        direction={isDesktopOrLaptop ? 'row' : 'column'}
                                        width={isDesktopOrLaptop ? 'unset' : '100%'}
                                        spacing={3}
                                    >
                                        <NissTextInput
                                            name={SIGNUP_FIELDS.SOCIAL_SECURITY_NUMBER}
                                            label={intl.formatMessage({id: 'login.form.signup.socialSecurityNumber.label'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.socialSecurityNumber.placeholder'})}
                                            helperText={intl.formatMessage({ id: 'login.form.signup.socialSecurityNumber.info' })}
                                            validate={required}
                                            format={toUpperCase}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                        <DatePickerInput
                                            name={SIGNUP_FIELDS.BIRTH_DATE}
                                            label={intl.formatMessage({id: 'login.form.signup.birthDate.label'})}
                                            validate={required}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                    </Stack>

                                    <Stack
                                        direction={isDesktopOrLaptop ? 'row' : 'column'}
                                        width={isDesktopOrLaptop ? 'unset' : '100%'}
                                        spacing={3}
                                    >
                                        <TextInput
                                            name={SIGNUP_FIELDS.EMAIL}
                                            type="email"
                                            label={intl.formatMessage({id: 'login.form.signup.email.label'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.email.placeholder'})}
                                            validate={required}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                        <TextInput
                                            name={SIGNUP_FIELDS.CONFIRM_EMAIL}
                                            label={intl.formatMessage({id: 'login.form.signup.confirmEmail'})}
                                            placeholder={intl.formatMessage({id: 'login.form.signup.email.placeholder'})}
                                            validate={required}
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                    </Stack>

                                    <Stack
                                        direction={isDesktopOrLaptop ? 'row' : 'column'}
                                        width={isDesktopOrLaptop ? 'unset' : '100%'}
                                        spacing={3}
                                    >
                                        <TextInput
                                            name={SIGNUP_FIELDS.PASSWORD}
                                            label={intl.formatMessage({id: 'login.form.signup.password.label'})}
                                            type="password"
                                            helperChecksNeedeed
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                        <TextInput
                                            name={SIGNUP_FIELDS.CONFIRM_PASSWORD}
                                            label={intl.formatMessage({id: 'login.form.signup.confirmPassword'})}
                                            type="password"
                                            maxWidth={isDesktopOrLaptop ? 'unset' : '100%'}
                                        />
                                    </Stack>

                                    <Stack direction="column" spacing={3} maxWidth="700px"
                                           borderRadius="5px" alignItems="center">
                                        <Box>
                                            <CheckboxInput
                                                name={SIGNUP_FIELDS.TERMS_AND_CONDITIONS}
                                                data={TERMS_AND_CONDITIONS_DATA as SelectOption[]}
                                                error={errors && errors[SIGNUP_FIELDS.TERMS_AND_CONDITIONS]}
                                            />
                                        </Box>
                                        <Box>
                                            <CaptchaInput name={SIGNUP_FIELDS.CAPTCHA_RESPONSE}
                                                          recaptchaRef={recaptchaRef}/>
                                        </Box>
                                    </Stack>
                                </Stack>

                                <Box display="flex" justifyContent="center">
                                    <ButtonDefault variant="contained" type="submit"
                                                   onClick={handleSubmit}>{intl.formatMessage({id: 'activationConjoint.form.signup.button'})}</ButtonDefault>
                                </Box>

                                <Box display="flex" width="100%" flex={1} alignSelf={isMobile || isTabletPortrait ? 'unset' : 'baseline'}>
                                    <Typography sx={{ position: isMobile || isTabletPortrait ? 'unset' : 'relative', bottom: '32px', left: 0, height: '32px', display: 'flex', alignItems: 'flex-end' }} variant="body2" color="#7a7a7a">
                                        <FormattedMessage id="global.mandatory" />
                                    </Typography>
                                </Box>
                            </Stack>
                        </form>
                    {confirmationArticle &&
                        <ConfirmationPopin
                            title={confirmationArticle.fields.title}
                            open={openConfirmation}
                            setOpen={setOpenConfirmation}
                            body={<div dangerouslySetInnerHTML={{__html: (confirmationArticle.fields.body)}}/>}
                            showActions={false}
                            resetForm={resetAction}
                        />
                    }
                </>
            )}
        />
    )
}

const mapStateToProps = (state: any) => ({
    confirmationArticle: cardiboxSelectors.articles.getByShortcut(state.cardibox)[ARTICLE_CONFIRMATION],
    introductionArticle: cardiboxSelectors.articles.getByShortcut(state.cardibox)[ARTICLE_INTRODUCTION]
})

export default connect(
    mapStateToProps,
    {
        getArticleByShortcut: cardiboxActions.articles.getByShortcut
    }
)(SignupFormConjoint)
